/* eslint-disable no-confusing-arrow */
import { merge } from 'ramda';

import {
  LOAD_SKILLS_REQUEST, LOAD_SKILLS_SUCCESS, LOAD_SKILLS_FAIL,
  POST_SKILLS_REQUEST, POST_SKILLS_SUCCESS, POST_SKILLS_FAIL,
  PUT_SKILLS_REQUEST, PUT_SKILLS_SUCCESS, PUT_SKILLS_FAIL,
  DELETE_SKILLS_REQUEST, DELETE_SKILLS_SUCCESS, DELETE_SKILLS_FAIL,
  LOAD_SKILL_SCALES_REQUEST, LOAD_SKILL_SCALES_SUCCESS, LOAD_SKILL_SCALES_FAIL,
  POST_SKILL_SCALES_REQUEST, POST_SKILL_SCALES_SUCCESS, POST_SKILL_SCALES_FAIL,
  PUT_SKILL_SCALES_REQUEST, PUT_SKILL_SCALES_SUCCESS, PUT_SKILL_SCALES_FAIL,
  DELETE_SKILL_SCALES_REQUEST, DELETE_SKILL_SCALES_SUCCESS, DELETE_SKILL_SCALES_FAIL,
  LOAD_SCALE_LEVELS_REQUEST, LOAD_SCALE_LEVELS_SUCCESS, LOAD_SCALE_LEVELS_FAIL,
  POST_SCALE_LEVELS_REQUEST, POST_SCALE_LEVELS_SUCCESS, POST_SCALE_LEVELS_FAIL,
  PUT_SCALE_LEVELS_REQUEST, PUT_SCALE_LEVELS_SUCCESS, PUT_SCALE_LEVELS_FAIL,
  DELETE_SCALE_LEVELS_REQUEST, DELETE_SCALE_LEVELS_SUCCESS, DELETE_SCALE_LEVELS_FAIL
} from 'src/store/actions/skillsActions';

export const skillsToOptions = (skills) => skills.map(({ Id, Name }) => ({ label: Name, value: Id }));

export const scalesToOptions = (scales) => scales.map(({ Id, Name }) => ({ label: Name, value: Id }));

export const scaleLevelsToOptions = (levels) => levels.map(({ Id, Name }) => ({ label: Name, value: Id }));

const initialState = {
  fetching: false,
  list: [],
  options: [],
  scalesFetching: false,
  scales: [],
  scalesOptions: [],
  scaleLevelsFetching: false,
  scaleLevels: [],
  scaleLevelsOptions: []
};

const updateSkill = (list, skill) => list.map((prof) => prof.Id === skill.Id ? skill : prof);

const deleteSkill = (list, skill) => list.filter(({ Id }) => Id !== skill.id);

const skillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SKILLS_REQUEST:
    case POST_SKILLS_REQUEST:
    case PUT_SKILLS_REQUEST:
    case DELETE_SKILLS_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_SKILLS_SUCCESS:
      return merge(state, {
        fetching: false,
        list: action.skills,
        options: skillsToOptions(action.skills)
      });
    case POST_SKILLS_SUCCESS: {
      const newList = [...state.list, action.skill];
      return merge(state, { list: newList, options: skillsToOptions(newList), fetching: false });
    }
    case PUT_SKILLS_SUCCESS: {
      const newList = updateSkill(state.list, action.skill);
      return merge(state, { list: newList, options: skillsToOptions(newList), fetching: false });
    }
    case DELETE_SKILLS_SUCCESS: {
      const newList = deleteSkill(state.list, action.skill);
      return merge(state, { list: newList, options: skillsToOptions(newList), fetching: false });
    }
    case LOAD_SKILLS_FAIL:
    case POST_SKILLS_FAIL:
    case PUT_SKILLS_FAIL:
    case DELETE_SKILLS_FAIL:
      return merge(state, { fetching: false });

    case LOAD_SKILL_SCALES_REQUEST:
    case POST_SKILL_SCALES_REQUEST:
    case PUT_SKILL_SCALES_REQUEST:
    case DELETE_SKILL_SCALES_REQUEST:
      return merge(state, { scalesFetching: true });
    case LOAD_SKILL_SCALES_SUCCESS:
      return merge(state, {
        scaleLevelsFetching: false,
        scales: action.scales,
        scalesOptions: scalesToOptions(action.scales)
      });
    case POST_SKILL_SCALES_SUCCESS: {
      const newList = [...state.scales, action.scale];
      return merge(state, { scales: newList, scalesOptions: scalesToOptions(newList), scalesFetching: false });
    }
    case PUT_SKILL_SCALES_SUCCESS: {
      const newList = updateSkill(state.scales, action.scale);
      return merge(state, { scales: newList, scalesOptions: scalesToOptions(newList), scalesFetching: false });
    }
    case DELETE_SKILL_SCALES_SUCCESS: {
      const newList = deleteSkill(state.scales, action.scale);
      return merge(state, { scales: newList, scalesOptions: scalesToOptions(newList), scalesFetching: false });
    }
    case LOAD_SKILL_SCALES_FAIL:
    case POST_SKILL_SCALES_FAIL:
    case PUT_SKILL_SCALES_FAIL:
    case DELETE_SKILL_SCALES_FAIL:
      return merge(state, { scalesFetching: false });

    case LOAD_SCALE_LEVELS_REQUEST:
    case POST_SCALE_LEVELS_REQUEST:
    case PUT_SCALE_LEVELS_REQUEST:
    case DELETE_SCALE_LEVELS_REQUEST:
      return merge(state, { scaleLevelsFetching: true });
    case LOAD_SCALE_LEVELS_SUCCESS:
      return merge(state, {
        fetching: false,
        scaleLevels: action.levels,
        scaleLevelsOptions: scaleLevelsToOptions(action.levels)
      });
    case POST_SCALE_LEVELS_SUCCESS: {
      const newList = [...state.scaleLevels, action.level];
      return merge(state, { scaleLevels: newList, scaleLevelsOptions: scaleLevelsToOptions(newList), scaleLevelsFetching: false });
    }
    case PUT_SCALE_LEVELS_SUCCESS: {
      const newList = updateSkill(state.scaleLevels, action.level);
      return merge(state, { scaleLevels: newList, scaleLevelsOptions: scaleLevelsToOptions(newList), scaleLevelsFetching: false });
    }
    case DELETE_SCALE_LEVELS_SUCCESS: {
      const newList = deleteSkill(state.scaleLevels, action.level);
      return merge(state, { scaleLevels: newList, scaleLevelsOptions: scaleLevelsToOptions(newList), scaleLevelsFetching: false });
    }
    case LOAD_SCALE_LEVELS_FAIL:
    case POST_SCALE_LEVELS_FAIL:
    case PUT_SCALE_LEVELS_FAIL:
    case DELETE_SCALE_LEVELS_FAIL:
      return merge(state, { scaleLevelsFetching: false });

    default:
      return state;
  }
};

export default skillsReducer;
